import { useSelector } from 'react-redux';
import { useMMSelector, useMMDispatch } from './withOwnReduxStore';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
import { isSpecialFullyLockedFolder, getCanEditGallection, canUseAsFolderCover, getCanLabelDeviationsInThisGallection } from '../helpers';
import { useCurrentGallection } from './withCurrentGallection';
import { useCurrentTier } from './withCurrentTier';
import { hasGallectionsToCopyOrMoveTo as hasGallectionsToCopyOrMoveToSelector } from '../selectors';
import { copyDeviations, makeDeviationCurrentGallectionCover, moveDeviations, removeDeviations } from '../actions';
import { useGruser } from './withGruser';
export const useManageDeviations = (selectedDeviations)=>{
    const dispatch = useMMDispatch();
    const hasCore = useSelector(getCurrentUserHasCore);
    const { currentGallection } = useCurrentGallection();
    const { currentTierId } = useCurrentTier();
    const { gruser } = useGruser();
    const hasGallectionsToCopyOrMoveTo = useMMSelector((state)=>hasGallectionsToCopyOrMoveToSelector(state, currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.folderId));
    const isTierContent = !!currentTierId;
    const isStash = (currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type) === 'stash';
    const isPrivateCollections = (currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type) === 'private_collection';
    const isCurrentGallectionPremium = !!(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.premiumFolderData);
    const selectionContainsPremiumDeviations = selectedDeviations.some((deviation)=>deviation.premiumFolderData);
    let isCopyToSupportedGlobally = true;
    let isMoveToSupportedGlobally = true;
    let isCopyToSupportedInThisFolder = true;
    let isMoveToSupportedInThisFolder = true;
    let isSettingCoverImageSupportedInThisFolder = true;
    let isRemoveSupportedInThisFolder = true;
    const isLabelAsSupportedInThisFolder = getCanLabelDeviationsInThisGallection(gruser, currentGallection);
    if (isTierContent || isStash || !hasGallectionsToCopyOrMoveTo) {
        isCopyToSupportedGlobally = false;
        isMoveToSupportedGlobally = false;
    }
    if (isCurrentGallectionPremium || selectionContainsPremiumDeviations) {
        isCopyToSupportedInThisFolder = false;
    }
    if (isSpecialFullyLockedFolder(currentGallection)) {
        isMoveToSupportedInThisFolder = false;
        isRemoveSupportedInThisFolder = false;
        isSettingCoverImageSupportedInThisFolder = false;
    }
    if (isPrivateCollections && !hasCore) {
        isCopyToSupportedInThisFolder = false;
        isMoveToSupportedInThisFolder = false;
    }
    if (currentGallection && !getCanEditGallection(currentGallection)) {
        isMoveToSupportedInThisFolder = false;
        isRemoveSupportedInThisFolder = false;
        isSettingCoverImageSupportedInThisFolder = false;
    }
    if (!canUseAsFolderCover(selectedDeviations[0])) {
        isSettingCoverImageSupportedInThisFolder = false;
    }
    return {
        isCopyToSupportedGlobally,
        isMoveToSupportedGlobally,
        isCopyToSupportedInThisFolder,
        isMoveToSupportedInThisFolder,
        isSettingCoverImageSupportedInThisFolder,
        isRemoveSupportedInThisFolder,
        isLabelAsSupportedInThisFolder,
        copyTo: (folderId)=>dispatch(copyDeviations({
                targetFolderId: folderId,
                deviations: selectedDeviations
            })),
        moveTo: (folderId)=>dispatch(moveDeviations({
                targetFolderId: folderId,
                deviations: selectedDeviations
            })),
        setDeviationAsCover: ()=>dispatch(makeDeviationCurrentGallectionCover(selectedDeviations[0])),
        remove: ()=>dispatch(removeDeviations(selectedDeviations))
    };
};

//# sourceMappingURL=withManageDeviations.js.map